import 'core-js/es6/map'
import 'core-js/es6/set'

import * as Sentry from '@sentry/browser'
import * as React from 'react'
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { SRPRS_ENV } from './env'
import './index.scss'
import Routes from './routing/routes'
import { settings } from './settings'
import { persistor, store } from './store/store'

function isBrowserSupported(userAgent: string) {
  return !(
    userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1
  )
}

if (isBrowserSupported(navigator.userAgent)) {
  // Sentry JS
  if (settings.sentryDsn) {
    const { release } = require('../version.json')
    Sentry.init({
      dsn: settings.sentryDsn,
      release,
      environment: SRPRS_ENV,
    })
  }
  const container = document.getElementById('content');
  const root = createRoot(container!);
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Routes />
      </PersistGate>
    </Provider>
  )
}
